import { Close, Delete, Description, Upload, Visibility } from "@mui/icons-material";
import {
  Autocomplete,
  Avatar,
  Box,
  Card,
  CardContent,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  Input,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { CustomButton } from "src/Components/Common/Button/CustomButton";
import LoadingIcon from "src/Components/Common/LoadingIcon";
import { DIALOG_MAX_WIDTHS } from "src/Components/Common/Modal/ModalWidth";
import useFetch from "src/Components/Common/useFetch";
import { userContext } from "src/Components/Contexts/userContext";
import CustomToast from "src/Components/CustomToast";
import { UserRole } from "src/entity/models/FrontendActor";
import { API_ENDPOINTS } from "src/Utils/ApiConstants/ApiUrlConstants";
import { convertUtcToIst } from "src/Utils/DateUtils";
import { AttachmentType, DepartmentType, DocType } from "../constants/disputeEntries";

const NonReconTakeActionDisputedEntries = ({
  selectedRowOfDisputedEntryForModal,
  openTakeActionModal,
  setOpenTakeActionModal,
  selectedRowIndex,
  disputedEntriesData,
  setDisputedEntriesData,
  setSummaryData,
  generateSummaryFromData,
  departmentName,
  allUsers,
  role,
}) => {
  const { actor } = useContext(userContext);
  const [fileInput, setFileInput] = useState<HTMLInputElement | null>(null);
  const [fileInputPod, setFileInputPod] = useState<HTMLInputElement | null>(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [podUploadedFiles, setPodUploadedFiles] = useState([]);

  // Individual form state variables
  const [vendorRemarks, setVendorRemarks] = useState("");
  const [arBtplRemark, setArBtplRemark] = useState("");
  const [categoryRemark, setCategoryRemark] = useState("");
  const [procurementRemark, setProcurementRemark] = useState("");
  const [warehouseRemarks, setWarehouseRemarks] = useState("");
  const [financeRemarks, setFinanceRemarks] = useState("");
  const [dependency, setDependency] = useState(selectedRowOfDisputedEntryForModal?.dependency || "");
  const [action, setAction] = useState(selectedRowOfDisputedEntryForModal?.action || "");
  const [resolutionStatus, setResolutionStatus] = useState(selectedRowOfDisputedEntryForModal?.resolutionStatus || "");
  const [actionOptions, setActionOptions] = useState([]);
  const [allActionOptions, setAllActionOptions] = useState([]);

  const [attachments, setAttachments] = useState([]);
  const [attachmentsPOD, setAttachmentsPOD] = useState([]);
  const [currentMaker, setCurrentMaker] = useState([]);
  const [currentChecker, setCurrentChecker] = useState([]);
  const [currentApprover, setCurrentApprover] = useState([]);

  const [poNumber, setPoNumber] = useState(selectedRowOfDisputedEntryForModal?.poNumber || "");
  const [invoiceNumber, setInvoiceNumber] = useState(selectedRowOfDisputedEntryForModal?.invoiceNumber || "");
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [organisationName, setOrganisationName] = useState(selectedRowOfDisputedEntryForModal?.organizationName || "");
  const [invoiceDate, setInvoiceDate] = useState(
    convertUtcToIst(selectedRowOfDisputedEntryForModal?.invoiceDate, "YYYY-MM-DD") || ""
  );
  const [invoiceAmount, setInvoiceAmount] = useState(selectedRowOfDisputedEntryForModal?.invoiceAmount || "");
  const [debitNoteNumber, setDebitNoteNumber] = useState(selectedRowOfDisputedEntryForModal?.instamartDNNumber || "");
  const [debitNoteDate, setDebitNoteDate] = useState(
    convertUtcToIst(selectedRowOfDisputedEntryForModal?.debitNoteDate, "YYYY-MM-DD") || ""
  );

  const [debitNoteAmount, setDebitNoteAmount] = useState(selectedRowOfDisputedEntryForModal?.dncnAmount || "");
  const [disputedAmount, setDisputedAmount] = useState(selectedRowOfDisputedEntryForModal?.disputedAmount || "");
  const [disputedReason, setDisputedReason] = useState(selectedRowOfDisputedEntryForModal?.disputedReason || "");

  const [oldValues, setOldValues] = useState({
    vendorRemarks: "",
    financeRemarks: "",
    warehouseRemarks: "",
    procurementRemarks: "",
    arBtplRemarks: "",
    categoryRemarks: "",
    gapValueId: selectedRowOfDisputedEntryForModal?.gapValueId || null,
    action: "",
    dependency: "",
    resolutionStatus: selectedRowOfDisputedEntryForModal?.resolutionStatus || "",
    approver: [],
    checker: [],
    maker: [],
  });

  const handleClose = () => {
    setOpenTakeActionModal(false);
    // remove this later
  };

  const handleFileUpload = (event) => {
    const selectedFiles = Array.from(event.target.files);
    const totalFiles = uploadedFiles.length + selectedFiles.length;

    if (totalFiles > 10) {
      toast.error(<CustomToast message="You can only upload up to 10 files." />);
      event.target.value = ""; // Clear input so same files can be re-selected
      return;
    }

    setUploadedFiles((prev) => [...selectedFiles, ...prev]);
    event.target.value = "";
  };

  const handlePODFileUpload = (event) => {
    const selectedFiles = Array.from(event.target.files);
    const totalFiles = podUploadedFiles.length + selectedFiles.length;

    if (totalFiles > 10) {
      toast.error(<CustomToast message="You can only upload up to 10 files." />);
      event.target.value = ""; // Clear input so same files can be re-selected
      return;
    }

    setPodUploadedFiles((prev) => [...selectedFiles, ...prev]);
    event.target.value = "";
  };

  const handleDelete = (index) => {
    setUploadedFiles((prev) => prev.filter((_, i) => i !== index));
  };
  const handleDeletePOD = (index) => {
    setPodUploadedFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const handleViewAttachment = (file) => {
    useFetch(API_ENDPOINTS.FETCH_DR_ENTRIES_ACTIONS_ATTACHMENTS_VIEW_NON_RECON.url, "POST", {
      failureMessage: API_ENDPOINTS.FETCH_DR_ENTRIES_ACTIONS_ATTACHMENTS_VIEW_NON_RECON.failureMessage,
      config: {
        params: {
          gapId: selectedRowOfDisputedEntryForModal.gapId,
          attachmentId: file.id,
        },
      },
      thenCallBack: (_res) => {
        const link = document.createElement("a");
        link.href = _res.data.data;
        link.target = "_blank";
        link.referrerPolicy = "no-referrer";
        link.style.display = "none";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // window.open(_res.data.attachment, "_blank", "noopener,noreferrer");
      },
    });
  };

  const handleActionOption = (e) => {
    const selectedAction = e.target.value;
    setAction(selectedAction);

    const matchingEntry = allActionOptions.find((entry) => entry.action === selectedAction);

    if (matchingEntry) {
      setDependency(matchingEntry.dependency);
      setResolutionStatus(matchingEntry.resolutionStatus);
    } else {
      setDependency("");
      setResolutionStatus("");
    }
  };

  // api integration--------------

  useEffect(() => {
    getTakeActionDataActionsOptions();
    getTakeActionDataActionAttachments(selectedRowOfDisputedEntryForModal?.gapId);
    getTakeActionDataRemarks(selectedRowOfDisputedEntryForModal?.gapId);
    getTakeActionDataActionOwner(selectedRowOfDisputedEntryForModal?.gapId);
  }, []);

  const getTakeActionDataActionAttachments = async (gapId) => {
    await useFetch(API_ENDPOINTS.FETCH_DR_ENTRIES_ACTION_ATTACHMENTS_NON_RECON(gapId).url, "GET", {
      failureMessage: API_ENDPOINTS.FETCH_DR_ENTRIES_ACTION_ATTACHMENTS_NON_RECON(gapId).failureMessage,
      thenCallBack: (response) => {
        const allAttachments = response.data.data || [];

        // Separate attachments based on AttachmentType
        const podAttachments = allAttachments.filter((attachment) => attachment.attachmentType === AttachmentType.POD);
        const otherAttachments = allAttachments.filter(
          (attachment) => attachment.attachmentType === AttachmentType.Others
        );

        setAttachmentsPOD(podAttachments);
        setAttachments(otherAttachments);
      },
      catchCallBack: () => {},
    });
  };

  const getTakeActionDataRemarks = async (gapId) => {
    await useFetch(API_ENDPOINTS.FETCH_DR_ENTRIES_REMARK_NON_RECON(gapId).url, "GET", {
      failureMessage: API_ENDPOINTS.FETCH_DR_ENTRIES_REMARK_NON_RECON(gapId).failureMessage,
      thenCallBack: (response) => {
        response.data?.data.forEach((item) => {
          if (item.department === "Vendor") {
            setVendorRemarks(item.remark);
            setOldValues((prev) => ({ ...prev, vendorRemarks: item.remark }));
          } else if (item.department === "Finance") {
            setFinanceRemarks(item.remark);
            setOldValues((prev) => ({ ...prev, financeRemarks: item.remark }));
          } else if (item.department === "Procurement") {
            setProcurementRemark(item.remark);
            setOldValues((prev) => ({ ...prev, procurementRemarks: item.remark }));
          } else if (item.department === "Warehouse") {
            setWarehouseRemarks(item.remark);
            setOldValues((prev) => ({ ...prev, warehouseRemarks: item.remark }));
          } else if (item.department === "AR/BTPL") {
            setArBtplRemark(item.remark);
            setOldValues((prev) => ({ ...prev, arBtplRemarks: item.remark }));
          } else if (item.department === "Category") {
            setCategoryRemark(item.remark);
            setOldValues((prev) => ({ ...prev, categoryRemarks: item.remark }));
          }
        });
      },
      catchCallBack: () => {},
    });
  };
  const getTakeActionDataActionOwner = async (gapId) => {
    await useFetch(API_ENDPOINTS.FETCH_DR_ENTRIES_ACTION_OWNERS_NON_RECON(gapId).url, "GET", {
      failureMessage: API_ENDPOINTS.FETCH_DR_ENTRIES_ACTION_OWNERS_NON_RECON(gapId).failureMessage,
      thenCallBack: (response) => {
        setCurrentMaker(response.data.data.maker || []);
        setCurrentChecker(response.data.data.checker || []);
        setCurrentApprover(response.data.data.approver || []);

        setOldValues((prev) => ({
          ...prev,
          maker: response.data.data.maker || [],
          checker: response.data.data.checker || [],
          approver: response.data.data.approver || [],
        }));
      },
      catchCallBack: () => {},
    });
  };
  const getTakeActionDataActionsOptions = async () => {
    await useFetch(API_ENDPOINTS.FETCH_DR_ENTRIES_ACTIONS_OPTIONS_NON_RECON.url, "GET", {
      failureMessage: API_ENDPOINTS.FETCH_DR_ENTRIES_ACTIONS_OPTIONS_NON_RECON.failureMessage,
      config: {
        params: {
          docType: selectedRowOfDisputedEntryForModal?.docType || "",
        },
      },
      thenCallBack: (response) => {
        setAllActionOptions(response.data?.data || []);

        // unique actions (based on selected gapReason)
        setActionOptions(
          Array.from(
            new Set(
              response.data?.data
                .filter((item) => item.gapReason === selectedRowOfDisputedEntryForModal?.gapReason)
                .map((item) => item.action)
            )
          ) || []
        );
      },
      catchCallBack: () => {},
    });
  };

  const handleSubmit = () => {
    setIsLoadingSubmit(true);
    updateTakeActionDataAction(selectedRowOfDisputedEntryForModal?.gapId);
  };

  const updateTakeActionDataAction = async (gapId) => {
    const newValuesData = {
      vendorRemarks: vendorRemarks,
      financeRemarks: financeRemarks,
      warehouseRemarks: warehouseRemarks,
      procurementRemarks: procurementRemark,
      arBtplRemarks: arBtplRemark,
      categoryRemarks: categoryRemark,
      gapValueId: allActionOptions.find((item) => item.action === action)?.id || null,
      action: action,
      dependency: dependency,
      resolutionStatus: resolutionStatus,
      // priority: currentPriority,
      // dueDate: currentDueDate,
      approver: currentApprover,
      checker: currentChecker,
      maker: currentMaker,
    };
    const bodyFormData = new FormData();

    // Add regular files with "Others" attachment type
    for (const item of uploadedFiles) {
      bodyFormData.append("Others", item);
    }

    // Add POD files with "POD" attachment type
    for (const item of podUploadedFiles) {
      bodyFormData.append("POD", item);
    }

    bodyFormData.append("userDepartment", departmentName || "");
    bodyFormData.append("oldValues", JSON.stringify(oldValues));
    bodyFormData.append("newValues", JSON.stringify(newValuesData));

    await useFetch(API_ENDPOINTS.UPDATE_DR_ENTRIES_ACTION_NON_RECON(gapId, role).url, "PUT", {
      failureMessage: API_ENDPOINTS.UPDATE_DR_ENTRIES_ACTION_NON_RECON(gapId, role).failureMessage,
      showSuccessToast: true,
      data: bodyFormData,
      thenCallBack: (_response) => {
        const updatedData = [...disputedEntriesData];
        if (selectedRowIndex !== null && selectedRowIndex !== undefined) {
          updatedData[selectedRowIndex] = {
            ...updatedData[selectedRowIndex],

            action: action,
            dependency: dependency,
            resolutionStatus: resolutionStatus,
            // priority: currentPriority,
            // dueDate: currentDueDate,
            // maker: currentMaker.map((maker) => maker.name).join(", "),
            // checker: currentChecker.map((checker) => checker.name).join(", "),
            // approver: currentApprover.map((approver) => approver.name).join(", "),
          };

          setDisputedEntriesData(updatedData);
          const summaryFromData = generateSummaryFromData(updatedData);
          setSummaryData(summaryFromData);
          setIsLoadingSubmit(false);
          handleClose();
        }
      },
      catchCallBack: () => {
        setIsLoadingSubmit(false);
      },
    });
  };

  // ------------------

  return (
    <>
      <Dialog open={openTakeActionModal} maxWidth={DIALOG_MAX_WIDTHS.SM} fullWidth>
        <DialogTitle className="dialog-title">
          <div className="heading-m">
            {selectedRowOfDisputedEntryForModal?.docType === DocType.Invoice
              ? "Invoice Missing"
              : selectedRowOfDisputedEntryForModal?.docType === DocType.PRRTV
              ? "PR/RTV Issue"
              : ""}{" "}
            - {selectedRowOfDisputedEntryForModal?.organizationName}
          </div>
          <div className="vertical_center_align">
            <IconButton onClick={handleClose}>
              <Close />
            </IconButton>
          </div>
        </DialogTitle>

        <DialogContent dividers sx={{ p: 3 }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
            <>
              {/* Conditional form fields based on doctype */}
              {selectedRowOfDisputedEntryForModal?.docType === DocType.Invoice ? (
                // Invoice fields
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  {/* Organisation Name */}
                  <TextField
                    className="update-custom-border-radius"
                    label="Organisation Name"
                    disabled
                    placeholder="-"
                    variant="outlined"
                    fullWidth
                    value={organisationName}
                    onChange={(e) => setOrganisationName(e.target.value)}
                    size="small"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        height: "40px",
                      },
                    }}
                  />

                  {/* Invoice Number and PO Number */}
                  <Box sx={{ display: "flex", gap: 2 }}>
                    <TextField
                      className="update-custom-border-radius"
                      label="Invoice Number"
                      disabled
                      placeholder="-"
                      variant="outlined"
                      fullWidth
                      value={invoiceNumber}
                      onChange={(e) => setInvoiceNumber(e.target.value)}
                      size="small"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          height: "40px",
                        },
                      }}
                    />
                    <TextField
                      className="update-custom-border-radius"
                      label="Invoice Date"
                      disabled
                      type="date"
                      variant="outlined"
                      fullWidth
                      value={invoiceDate}
                      onChange={(e) => setInvoiceDate(e.target.value)}
                      size="small"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          height: "40px",
                        },
                      }}
                    />
                  </Box>

                  {/* Invoice Date and Invoice Amount */}
                  <Box sx={{ display: "flex", gap: 2 }}>
                    <TextField
                      className="update-custom-border-radius"
                      label="PO Number"
                      disabled
                      placeholder="-"
                      variant="outlined"
                      fullWidth
                      value={poNumber}
                      onChange={(e) => setPoNumber(e.target.value)}
                      size="small"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          height: "40px",
                        },
                      }}
                    />
                    <TextField
                      className="update-custom-border-radius"
                      label="Invoice Amount"
                      disabled
                      type="number"
                      placeholder="-"
                      variant="outlined"
                      fullWidth
                      value={invoiceAmount}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value === "" || /^\d*\.?\d*$/.test(value)) {
                          setInvoiceAmount(value);
                        }
                      }}
                      size="small"
                      inputProps={{
                        min: 0,
                        step: "0.01",
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          height: "40px",
                        },
                      }}
                    />
                  </Box>
                </Box>
              ) : (
                selectedRowOfDisputedEntryForModal?.docType === DocType.PRRTV && (
                  // PR/RTV fields
                  <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                    {/* Organisation Name */}
                    <TextField
                      className="update-custom-border-radius"
                      label="Organisation Name"
                      disabled
                      placeholder="-"
                      variant="outlined"
                      fullWidth
                      value={organisationName}
                      onChange={(e) => setOrganisationName(e.target.value)}
                      size="small"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          height: "40px",
                        },
                      }}
                    />

                    {/* Debit Note Number and Invoice Number */}
                    <Box sx={{ display: "flex", gap: 2 }}>
                      <TextField
                        className="update-custom-border-radius"
                        label="Debit Note Number"
                        disabled
                        placeholder="-"
                        variant="outlined"
                        fullWidth
                        value={debitNoteNumber}
                        onChange={(e) => setDebitNoteNumber(e.target.value)}
                        size="small"
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            height: "40px",
                          },
                        }}
                      />
                      <TextField
                        className="update-custom-border-radius"
                        label="Invoice Number"
                        disabled
                        placeholder="-"
                        variant="outlined"
                        fullWidth
                        value={invoiceNumber}
                        onChange={(e) => setInvoiceNumber(e.target.value)}
                        size="small"
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            height: "40px",
                          },
                        }}
                      />
                    </Box>

                    {/* Debit Note Date and Debit Note Amount */}
                    <Box sx={{ display: "flex", gap: 2 }}>
                      <TextField
                        className="update-custom-border-radius"
                        label="Debit Note Date"
                        disabled
                        type="date"
                        variant="outlined"
                        fullWidth
                        value={debitNoteDate}
                        onChange={(e) => setDebitNoteDate(e.target.value)}
                        size="small"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            height: "40px",
                          },
                        }}
                      />
                      <TextField
                        className="update-custom-border-radius"
                        label="Debit Note Amount"
                        disabled
                        type="number"
                        placeholder="-"
                        variant="outlined"
                        fullWidth
                        value={debitNoteAmount}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value === "" || /^\d*\.?\d*$/.test(value)) {
                            setDebitNoteAmount(value);
                          }
                        }}
                        size="small"
                        inputProps={{
                          min: 0,
                          step: "0.01",
                        }}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            height: "40px",
                          },
                        }}
                      />
                    </Box>

                    {/* Disputed Amount */}
                    <TextField
                      className="update-custom-border-radius"
                      label="Disputed Amount"
                      disabled
                      type="number"
                      placeholder="-"
                      variant="outlined"
                      fullWidth
                      value={disputedAmount}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value === "" || /^\d*\.?\d*$/.test(value)) {
                          setDisputedAmount(value);
                        }
                      }}
                      size="small"
                      inputProps={{
                        min: 0,
                        step: "0.01",
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          height: "40px",
                        },
                      }}
                    />

                    <TextField
                      className="update-custom-border-radius"
                      label="Reason of Issue"
                      disabled
                      placeholder="-"
                      variant="outlined"
                      fullWidth
                      value={disputedReason}
                      onChange={(e) => setDisputedReason(e.target.value)}
                      size="small"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          height: "40px",
                        },
                      }}
                    />
                  </Box>
                )
              )}
            </>

            {/* Upload POD Document Section */}
            <Card sx={{ border: "1px solid #d6d6d6" }}>
              <CardContent sx={{ padding: "16px 24px" }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <Box>
                    <Typography className="heading-xs">Upload POD</Typography>

                    <Typography className="body-s-medium" color="textSecondary">
                      Attach your doc file here (supported formats PDF, JPG, PNG). File size limit 50MB.
                    </Typography>
                  </Box>

                  <>
                    <Input
                      type="file"
                      inputRef={(ref) => setFileInputPod(ref)}
                      sx={{ display: "none" }}
                      onChange={handlePODFileUpload}
                      inputProps={{
                        accept: ".pdf,.jpg,.png,.xlsx,.xls",
                        multiple: true,
                      }}
                    />
                    <CustomButton
                      size="small"
                      colorToken="violet"
                      variant="outlined"
                      startIcon={<Upload />}
                      onClick={() => fileInputPod?.click()}
                      disabled={podUploadedFiles.length >= 10}
                    >
                      Upload
                    </CustomButton>
                  </>
                </Box>
              </CardContent>

              {podUploadedFiles.map((file, index) => (
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "8px 24px",
                    backgroundColor: "#f2f2f2",
                    borderTop: "1px solid #d6d6d6",
                  }}
                >
                  <Chip
                    avatar={
                      <Avatar sx={{ backgroundColor: "#541c4c", color: "white" }}>
                        <Description sx={{ fontSize: 14, color: "white" }} />
                      </Avatar>
                    }
                    label={
                      <Box
                        title={file.name}
                        sx={{
                          maxWidth: "250px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {file.name}
                      </Box>
                    }
                    variant="outlined"
                    sx={{
                      maxWidth: "250px",
                      borderColor: "#541c4c",
                      color: "#541c4c",
                      flex: 1,
                    }}
                  />
                  <Box sx={{ display: "flex", gap: 1, flexShrink: 0 }}>
                    <CustomButton
                      size="small"
                      color="error"
                      variant="outlined"
                      startIcon={<Delete />}
                      onClick={() => handleDeletePOD(index)}
                    >
                      Delete
                    </CustomButton>
                  </Box>
                </Box>
              ))}

              {attachmentsPOD?.length > 0 &&
                attachmentsPOD?.map((file, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "8px 24px",
                      backgroundColor: "#f2f2f2",
                      borderTop: "1px solid #d6d6d6",
                    }}
                  >
                    <Chip
                      avatar={
                        <Avatar sx={{ backgroundColor: "#541c4c", color: "white" }}>
                          <Description sx={{ fontSize: 14, color: "white" }} />
                        </Avatar>
                      }
                      label={
                        <Box
                          title={file.fileName}
                          sx={{
                            maxWidth: "250px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {file.fileName}
                        </Box>
                      }
                      variant="outlined"
                      sx={{
                        maxWidth: "250px",
                        borderColor: "#541c4c",
                        color: "#541c4c",
                        flex: 1, // Allow the chip to take available space
                      }}
                    />
                    <Box sx={{ display: "flex", gap: 1, flexShrink: 0 }}>
                      <CustomButton
                        size="small"
                        colorToken="violet"
                        variant="outlined"
                        startIcon={<Visibility />}
                        onClick={() => handleViewAttachment(file)}
                      >
                        View
                      </CustomButton>
                    </Box>
                  </Box>
                ))}
            </Card>

            {/* Upload Document Section */}
            {selectedRowOfDisputedEntryForModal?.docType === DocType.Invoice && (
              <Card sx={{ border: "1px solid #d6d6d6" }}>
                <CardContent sx={{ padding: "16px 24px" }}>
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Box>
                      <Typography className="heading-xs">Upload Document</Typography>

                      <Typography className="body-s-medium" color="textSecondary">
                        Attach your doc file here (supported formats PDF, JPG, PNG). File size limit 50MB.
                      </Typography>
                    </Box>

                    <>
                      <Input
                        type="file"
                        inputRef={(ref) => setFileInput(ref)}
                        sx={{ display: "none" }}
                        onChange={handleFileUpload}
                        inputProps={{
                          accept: ".pdf,.jpg,.png,.xlsx,.xls",
                          multiple: true,
                        }}
                      />
                      <CustomButton
                        size="small"
                        colorToken="violet"
                        variant="outlined"
                        startIcon={<Upload />}
                        onClick={() => fileInput?.click()}
                        disabled={uploadedFiles.length >= 10}
                      >
                        Upload
                      </CustomButton>
                    </>
                  </Box>
                </CardContent>

                {uploadedFiles.map((file, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "8px 24px",
                      backgroundColor: "#f2f2f2",
                      borderTop: "1px solid #d6d6d6",
                    }}
                  >
                    <Chip
                      avatar={
                        <Avatar sx={{ backgroundColor: "#541c4c", color: "white" }}>
                          <Description sx={{ fontSize: 14, color: "white" }} />
                        </Avatar>
                      }
                      label={
                        <Box
                          title={file.name}
                          sx={{
                            maxWidth: "250px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {file.name}
                        </Box>
                      }
                      variant="outlined"
                      sx={{
                        maxWidth: "250px",
                        borderColor: "#541c4c",
                        color: "#541c4c",
                        flex: 1,
                      }}
                    />
                    <Box sx={{ display: "flex", gap: 1, flexShrink: 0 }}>
                      <CustomButton
                        size="small"
                        color="error"
                        variant="outlined"
                        startIcon={<Delete />}
                        onClick={() => handleDelete(index)}
                      >
                        Delete
                      </CustomButton>
                    </Box>
                  </Box>
                ))}

                {attachments?.length > 0 &&
                  attachments?.map((file, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "8px 24px",
                        backgroundColor: "#f2f2f2",
                        borderTop: "1px solid #d6d6d6",
                      }}
                    >
                      <Chip
                        avatar={
                          <Avatar sx={{ backgroundColor: "#541c4c", color: "white" }}>
                            <Description sx={{ fontSize: 14, color: "white" }} />
                          </Avatar>
                        }
                        label={
                          <Box
                            title={file.fileName}
                            sx={{
                              maxWidth: "250px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {file.fileName}
                          </Box>
                        }
                        variant="outlined"
                        sx={{
                          maxWidth: "250px",
                          borderColor: "#541c4c",
                          color: "#541c4c",
                          flex: 1, // Allow the chip to take available space
                        }}
                      />
                      <Box sx={{ display: "flex", gap: 1, flexShrink: 0 }}>
                        <CustomButton
                          size="small"
                          colorToken="violet"
                          variant="outlined"
                          startIcon={<Visibility />}
                          onClick={() => handleViewAttachment(file)}
                        >
                          View
                        </CustomButton>
                      </Box>
                    </Box>
                  ))}
              </Card>
            )}

            {/* Action Form Fields */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              {/* Action */}
              <FormControl fullWidth size="small" className="update-custom-border-radius">
                <InputLabel>Action</InputLabel>
                <Select
                  value={action}
                  label="Action"
                  onChange={handleActionOption}
                  sx={{
                    height: "40px",
                  }}
                >
                  {actionOptions.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/* Dependency */}
              {/* <FormControl fullWidth size="small"  className="update-custom-border-radius">
                <InputLabel>Dependency</InputLabel>
                <Select
                  value={dependency}
                  label="Dependency"
                  onChange={(e) => setDependency(e.target.value)}
                  sx={{
                    height: '40px'
                  }}
                >
                  {dependencyOptions.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl> */}
              <TextField
                className="update-custom-border-radius"
                label="Dependency"
                placeholder="-"
                variant="outlined"
                fullWidth
                value={dependency}
                onChange={(e) => setDependency(e.target.value)}
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "40px",
                  },
                }}
                disabled
              />
              {/* Resolution Status */}
              {/* <FormControl fullWidth size="small"  className="update-custom-border-radius">
                <InputLabel>Resolution Status</InputLabel>
                <Select
                  value={resolutionStatus}
                  label="Resolution Status"
                  onChange={(e) => setResolutionStatus(e.target.value)}
                  sx={{
                    height: '40px'
                  }}
                >
                  {resolutionStatusOptions.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl> */}
              <TextField
                className="update-custom-border-radius"
                label="Resolution Status"
                placeholder="-"
                variant="outlined"
                fullWidth
                value={resolutionStatus}
                onChange={(e) => setResolutionStatus(e.target.value)}
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "40px",
                  },
                }}
                disabled
              />

              <TextField
                className="update-custom-border-radius"
                label="Vendor Remarks"
                placeholder="-"
                variant="outlined"
                fullWidth
                value={vendorRemarks}
                onChange={(e) => setVendorRemarks(e.target.value)}
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "40px",
                  },
                }}
                disabled={departmentName === DepartmentType.Vendor ? false : true}
              />
              <TextField
                className="update-custom-border-radius"
                label="Finance Remarks"
                placeholder="-"
                variant="outlined"
                fullWidth
                value={financeRemarks}
                onChange={(e) => setFinanceRemarks(e.target.value)}
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "40px",
                  },
                }}
                disabled={departmentName === DepartmentType.Finance ? false : true}
              />
              <TextField
                className="update-custom-border-radius"
                label="Warehouse Remarks"
                placeholder="-"
                variant="outlined"
                fullWidth
                value={warehouseRemarks}
                onChange={(e) => setWarehouseRemarks(e.target.value)}
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "40px",
                  },
                }}
                disabled={departmentName === DepartmentType.Warehouse ? false : true}
              />
              <TextField
                className="update-custom-border-radius"
                label="Procurement Remark"
                placeholder="-"
                variant="outlined"
                fullWidth
                value={procurementRemark}
                onChange={(e) => setProcurementRemark(e.target.value)}
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "40px",
                  },
                }}
                disabled={departmentName === DepartmentType.Procurement ? false : true}
              />

              <TextField
                className="update-custom-border-radius"
                label="AR/ BTPL Remark"
                placeholder="-"
                variant="outlined"
                fullWidth
                value={arBtplRemark}
                onChange={(e) => setArBtplRemark(e.target.value)}
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "40px",
                  },
                }}
                disabled={
                  departmentName === DepartmentType.ARTeam || departmentName === DepartmentType.BTPL ? false : true
                }
              />

              <TextField
                className="update-custom-border-radius"
                label="Category Remark"
                placeholder="-"
                variant="outlined"
                fullWidth
                value={categoryRemark}
                onChange={(e) => setCategoryRemark(e.target.value)}
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "40px",
                  },
                }}
                disabled={departmentName === DepartmentType.Category ? false : true}
              />

              <Autocomplete
                multiple
                size="small"
                value={currentMaker}
                onChange={(_, newValue) => {
                  setCurrentMaker(newValue);
                }}
                sx={{ width: "100%", "& fieldset": { borderRadius: "4px" } }}
                disableClearable
                options={allUsers} // Show all users
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderOption={(props, item) => (
                  <li {...props} key={item.id}>
                    <ListItemText>{item.name}</ListItemText>
                  </li>
                )}
                getOptionLabel={(option: { name: string; id: number }) => option.name}
                renderInput={(params) => <TextField {...params} label="Maker" size="small" />}
              />
              {(actor.userRole === UserRole.DRApprover ||
                actor.userRole === UserRole.DRChecker ||
                actor.userRole === UserRole.ReconDRApprover) && (
                <Autocomplete
                  multiple
                  size="small"
                  value={currentChecker}
                  onChange={(_, newValue) => {
                    setCurrentChecker(newValue);
                  }}
                  sx={{ width: "100%", "& fieldset": { borderRadius: "4px" } }}
                  disableClearable
                  options={allUsers?.filter(
                    (user) =>
                      user.role === UserRole.DRChecker ||
                      user.role === UserRole.DRApprover ||
                      user.role === UserRole.ReconDRApprover
                  )} // Filter users by role
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                  renderOption={(props, item) => (
                    <li {...props} key={item.id}>
                      <ListItemText>{item.name}</ListItemText>
                    </li>
                  )}
                  getOptionLabel={(option: { name: string; id: number }) => option.name}
                  renderInput={(params) => <TextField {...params} label="Checker" size="small" />}
                />
              )}

              {(actor.userRole === UserRole.DRApprover || actor.userRole === UserRole.ReconDRApprover) && (
                <Autocomplete
                  multiple
                  size="small"
                  value={currentApprover}
                  onChange={(_, newValue) => {
                    setCurrentApprover(newValue);
                  }}
                  sx={{ width: "100%", "& fieldset": { borderRadius: "4px" } }}
                  disableClearable
                  options={allUsers?.filter(
                    (user) => user.role === UserRole.DRApprover || user.role === UserRole.ReconDRApprover
                  )} // Filter users by role
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                  renderOption={(props, item) => (
                    <li {...props} key={item.id}>
                      <ListItemText>{item.name}</ListItemText>
                    </li>
                  )}
                  getOptionLabel={(option: { name: string; id: number }) => option.name}
                  renderInput={(params) => <TextField {...params} label="Approver" size="small" />}
                />
              )}

              {/* <TextField
                type="date"
                InputProps={{
                  style: {
                    borderRadius: "4px",
                  },
                }}
                value={currentDueDate}
                sx={{ width: "100%" }}
                size="small"
                label="Due Date"
                InputLabelProps={{ shrink: true }}
                onChange={(e) => {
                  setCurrentDueDate(e.target.value);
                }}
                disabled={actor.userRole === UserRole.ReconDRApprover ? false : true}
              /> */}
            </Box>
          </Box>
        </DialogContent>
        <DialogActions className="dialog-actions">
          <CustomButton size="medium" colorToken="violet" variant="outlined" onClick={handleClose}>
            Cancel
          </CustomButton>
          <CustomButton
            size="medium"
            colorToken="violet"
            variant="contained"
            disabled={isLoadingSubmit}
            startIcon={<LoadingIcon loading={isLoadingSubmit} />}
            onClick={handleSubmit}
          >
            Update
          </CustomButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default NonReconTakeActionDisputedEntries;
